import { hasValue } from '@progress-fe/core';
import { ERFElement } from '../enums';
/**
 * Check that connector has "energy" type.
 * HandleId examples: "target_material_1", "source_energy_1", "source_logical_1" ...
 */
export const isEnergyPort = (handleId) => {
    if (!handleId)
        return false;
    return handleId.split('_')[1] === 'energy';
};
/**
 * Check that connector has "logical" type.
 * HandleId examples: "target_material_1", "source_energy_1", "source_logical_1" ...
 */
export const isLogicalPort = (handleId) => {
    if (!handleId)
        return false;
    return handleId.split('_')[1] === 'logical';
};
/**
 * Check that connectors have the same type.
 * HandleId examples: "target_material_1", "source_energy_1", "source_logical_1" ...
 */
export const portsHaveSameFlowType = (portA, portB) => {
    if (!portA || !portB)
        return false;
    return portA.split('_')[1] === portB.split('_')[1];
};
/**
 * Create unique code for connector.
 * E.g.: "target_material_1", "source_energy_1" ...
 */
export const createPortCode = (portType, flowType, suffix) => {
    return suffix ? `${portType}_${flowType}_${suffix}` : `${portType}_${flowType}`;
};
/**
 * Check that node type is a "flowMaterial" or "flowEnergy".
 */
export const isFlowNode = (type) => {
    const targetTypes = [ERFElement.FlowMaterial.toString(), ERFElement.FlowEnergy.toString()];
    return hasValue(type) ? targetTypes.includes(type.toString()) : false;
};
/**
 * Check that node type is NOT a "flowMaterial" or "flowEnergy".
 */
export const isNotFlowNode = (type) => {
    const targetTypes = [ERFElement.FlowMaterial.toString(), ERFElement.FlowEnergy.toString()];
    return hasValue(type) ? !targetTypes.includes(type.toString()) : false;
};
/**
 * Check that connection is valid.
 */
export const isConnectionValid = (connection, nodes) => {
    const { source, target, sourceHandle, targetHandle } = connection;
    const sourceNode = nodes.find((n) => n.id === source);
    const targetNode = nodes.find((n) => n.id === target);
    const areHandlesValid = !!sourceHandle && !!targetHandle;
    const isLogicValid = portsHaveSameFlowType(sourceHandle, targetHandle);
    const areFlowNodes = isFlowNode(sourceNode?.type) && isFlowNode(targetNode?.type);
    return !!sourceNode && !!targetNode && areHandlesValid && isLogicValid && !areFlowNodes;
};
//# sourceMappingURL=node.utils.js.map